import { render, staticRenderFns } from "./privte.vue?vue&type=template&id=c4cbdf86&scoped=true&"
import script from "./privte.vue?vue&type=script&lang=js&"
export * from "./privte.vue?vue&type=script&lang=js&"
import style0 from "./privte.vue?vue&type=style&index=0&id=c4cbdf86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cbdf86",
  null
  
)

export default component.exports